import { AlertProps, Alert as AntAlert } from 'antd'

const Alert = (props: AlertProps) => {
    return <AntAlert {...props} />
}

export default Alert
